import { NOTIFICATION_PRIVATE } from './privates';
import { ConstructNotification } from './constructor';
export function NotificationGetName(instance) {
    return instance[NOTIFICATION_PRIVATE].name;
}
export function NotificationGetValue(instance) {
    return instance[NOTIFICATION_PRIVATE].value;
}
export function NotificationToJSON(instance) {
    return {
        name: instance.name,
        value: instance.value,
    };
}
export function NotificationStaticFromEvent(_constructor, event) {
    return new _constructor(event.type, event);
}
export class Notification {
    static fromEvent(event) {
        return NotificationStaticFromEvent(this, event);
    }
    constructor(name, value) {
        ConstructNotification(this, name, value);
    }
    get name() {
        return NotificationGetName(this);
    }
    get value() {
        return NotificationGetValue(this);
    }
    toJSON() {
        return NotificationToJSON(this);
    }
}
//# sourceMappingURL=implementation.js.map